import * as React from "react"
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { ExtDataGW } from "./ExtDataGW"
import { ExtInfoViewGW } from "./ExtInfoViewGW"
import { ArticleItemGW } from "./ArticleItemGW"

interface RadioBtnVm {
    app: App,
    extData: ExtDataGW,
    article: ArticleGW,
    extInfoView: ExtInfoViewGW,
    options: string[],
    radioHeight: number
}

interface RadioState {
    position:number
}

/* ExtInfoRadioBtnGW is a component used within the extended info view showing several sections of
   choises, first (left) is the supplier, second (middle) is the package unit, and finally some
   stats for the selected backage unit will be displayed to the right, along with a flags for the
   package's availability for purchase. Techially there is also options for verions of the same
   package unit, in case the supplier has registered several versions, but typically these
   options won't be shown since most packages only have one set of given properties. If shown, these
   options will be positioned right above the given stats for the package unit.
   Options which has been added amounts into are displayed with a * sign before their names, to
   give overview of where the chosen amounts are occuring among these options, so that they may
   easily be found again and be edited or removed by the user. */

export class ExtInfoRadioButton extends React.Component<RadioBtnVm, RadioState> {

    state: RadioState = {
        position: 0
    }
    
    constructor(props: RadioBtnVm){
        super(props);
        this.m_index = 0
    }

    // Handler for clicks on Supplier radio buttons
    OnClickLev(lev: number) {
        this.props.app.GetCore().FinishOngoingInput()
        this.props.extData.SetValgtLeverantorIndex(lev)
        this.props.extData.SetHoveredLeverantorIndex(-1)
        this.props.extData.SetValgtPakkeIndex(0)
        this.props.extData.SetHoveredPakkeIndex(-1)
        this.props.extData.SetValgtDimIndex(0)
        this.props.extData.SetHoveredDimIndex(-1)
        this.props.app.GetCore().UpdateSelectedItem()
        this.props.extInfoView.forceUpdate()
    }

    // Handler for clicks on Package Unit radio buttons
    OnClickEnh(enh: number) {
        this.props.app.GetCore().FinishOngoingInput()
        this.props.extData.SetValgtPakkeIndex(enh)
        this.props.extData.SetHoveredPakkeIndex(-1)
        this.props.extData.SetValgtDimIndex(0)
        this.props.extData.SetHoveredDimIndex(-1)
        this.props.app.GetCore().UpdateSelectedItem()
        this.props.extInfoView.forceUpdate()
    }

    // Handler for clicks on Unit Dimensions radio buttons
    OnClickDim(dim: number) {
        // this.props.app.GetCore().FinishOngoingInput()
        this.props.extData.SetValgtDimIndex(dim)
        this.props.extData.SetHoveredDimIndex(-1)
        // this.props.app.GetCore().UpdateSelectedItem()
        this.props.extInfoView.forceUpdate()
    }

    // Hovering over media links will shine them up
    OnMouseEnterMediaLink(index: number) {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredMediaLink(index)
        this.props.extData.SetHoveredLeverantorIndex(-1)
        this.props.extData.SetHoveredPakkeIndex(-1)
        this.props.extData.SetHoveredDimIndex(-1)
        this.forceUpdate()
    }

    // Leaving the area for the media links will unlight them all
    OnMouseLeaveMedia() {
        var extData = this.props.app.GetCore().GetExtData();
        extData && extData.SetHoveredMediaLink(-1)
        this.forceUpdate()
    }

    // DescribeMediaType tries to recognize what the short version of a media description stands for and if so returns a more descriptive string instead of these few given letters
    DescribeMediaType(desc: string) {
        if (desc == "PRE") {
            return "Produktdatablad"
        }

        if (desc == "MAN") {
            return "Monteringsanvisning"
        }

        if (desc == "HMF") {
            return "Helse, miljø og sikkerhet faktablad"
        }

        if (desc == "HMS") {
            return "Sikkerhetsdatablad"
        }

        if (desc == "SER") {
            return "Sertifikat"
        }

        if (desc == "FDV") {
            return "Forvaltning, drift og vedlikehold"
        }

        if (desc == "BRO") {
            return "Brosjyre"
        }

        if (desc == "MLJ") {
            return "Miljødeklarasjon"
        }

        if (desc == "IFC") {
            return "Industry foundation classes"
        }

        if (desc == "EPD") {
            return "Miljødeklarasjon"
        }

        if (desc == "YTE") {
            return "Ytelseserklæring"
        }

        if (desc == "BREEAM") {
            return "Egenerklæring"
        }

        if (desc == "MTG") {
            return "Målsatt tegning"
        }

        if (desc == "ESDS") {
            return "Eksponeringssikkerhetsdatablad"
        }

        if (desc == "VB") {
            return "Verneblad"
        }

        if (desc == "PB") {
            return "Produktbilde"
        }

        if (desc == "MB") {
            return "Miljøbilde"
        }

        if ((desc == "") || (desc == null)) {
            return "uspesifisert lenke"
        }

        /*  As default, the unchanged description string is returned as it is. The above descriptions are taken from this documentation page:
         *  http://dok.byggtjeneste.no/importeksport/#VareEksport%208.0_xsd~c-MedierType.html  ..which won't cover all possible media types today,
         *  so if you find more descriptions for other types not enlisted above, please add them as well here above  ^                     */
        return desc
    }
    
    /* If more than one product info link have the same type, an " #1", " #2" and so on will be added in the end of that description, to give
     * it some sense of identity and so that the user may keep track of which one was last he/she clicked upon.   */
    GetNumericExtension(index: number) {
        const extData = this.props.app.GetCore().GetExtData()
        const type = extData && extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[index].mediaType
        var thisInOrder = 0
        var totalSimilar = 0

        for (var i = 0; extData && i < extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier.length; i++) {
            const current = i
            if (type == extData.GetLeverandorer()[extData.GetValgtLeverantorIndex()].medier[current].mediaType) {
                if (current == index) {
                    thisInOrder = totalSimilar + 1
                }

                totalSimilar++
            }
        }

        if (totalSimilar > 1) {
            return " #" + thisInOrder.toString()
        }
        else {
            return ""
        }
    }

    // Produces an unique index for radio button id's
    GetUnique() {
        const previous = this.m_index
        this.m_index++
        return previous
    }
    
    // Renders the entire radio buttons area with all 3 sections
    render() {
        // turns the offset into a string that will be used to position the background image
        const offset = 136
        const bgPosition = "0px -" + offset.toString() + "px"
        const bgPosition2 = "0px -" + (offset + 18).toString() + "px"
        const buttonHeight = 17
        const buttonHeightStr = buttonHeight.toString() + "px"
        const buttonWidth = 16
        const buttonWidthStr = buttonWidth.toString() + "px"
        const heightStr = this.props.radioHeight.toString() + "px"
        const widthRemainStr = "calc(100% - " + (buttonWidth + 80).toString() + "px)"

        // Two arrays of radio buttons will be rendered, held by the following buffers
        var bufferLev = new Array<JSX.Element>()
        var bufferEnh = new Array<JSX.Element>()
        var bufferDim = new Array<JSX.Element>()

        // Preparing the radio button options for supplier (leverantør)
        for (var i = 0; i < this.props.extData.GetLeverandorer().length; i++) {
            const k = i
            const offsetStr = "0px -" + (offset + (18 * ((this.props.extData.GetValgtLeverantorIndex() == k) ? 1 : ((this.props.extData.GetHoveredLeverantorIndex() == k) ? 2 : 0)))).toString() + "px"
            const textColorStr = ((this.props.extData.GetValgtLeverantorIndex() == k) ? "#000000" : ((this.props.extData.GetHoveredLeverantorIndex() == k) ? "#000000" : "#333844"))
            const fontWeightStr = ((this.props.extData.GetValgtLeverantorIndex() == k) ? "bold" : ((this.props.extData.GetHoveredLeverantorIndex() == k) ? "normal" : "normal"))
            const titleStr = (k == 0) ? "Leverandør:" : ""

            var hasContents = false

            for (var p = 0; p < this.props.extData.GetLeverandorer()[k].pakninger.length; p++) {
                if (this.props.extData.GetLeverandorer()[k].pakninger[p].amount != 0) {
                    hasContents = true
                    break
                }
            }

            const checkedClass = (this.props.extData.GetValgtLeverantorIndex() == k) ? "extInfoRadioButton checked" : "extInfoRadioButton"
            const plural = (hasContents) ? "* " : ""

            if (this.props.extData.GetLeverandorer().length > 1) {
                bufferLev.push(
                    <div key={this.GetUnique()} onClick={e => this.OnClickLev(k)} className={checkedClass}>
                        <h5 className="prefix" style={{width:"80px"}}>{titleStr}</h5>
                        <div className="centerfix" style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", position: "relative", top: "3px", left: "8px" }}></div>
                        <h5 className="postfix" style={{width:"250px"}}>{plural + this.props.extData.GetLeverandorer()[k].navn}</h5>
                    </div>)
            }
            else {
                bufferLev.push(
                    <div key={this.GetUnique()} onClick={e => this.OnClickEnh(k)} style={{ height: "20px", display: "flex", flexDirection: "row", cursor: "pointer" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>{titleStr}</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844", fontWeight: "normal" }}>{plural + this.props.extData.GetLeverandorer()[k].navn}</h5>
                    </div>)
            }
        }

        // Preparing radio options for unit (enhet)
        for (i = 0; i < this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger.length; i++) {
            const k = i
            const offsetStr = "0px -" + (offset + (18 * ((this.props.extData.GetValgtPakkeIndex() == k) ? 1 : ((this.props.extData.GetHoveredPakkeIndex() == k) ? 2 : 0)))).toString() + "px"
            const textColorStr = ((this.props.extData.GetValgtPakkeIndex() == k) ? "#000000" : ((this.props.extData.GetHoveredPakkeIndex() == k) ? "#000000" : "#333844"))
            const fontWeightStr = ((this.props.extData.GetValgtPakkeIndex() == k) ? "bold" : ((this.props.extData.GetHoveredPakkeIndex() == k) ? "normal" : "normal"))
            const titleStrB = (k == 0) ? "Enhet:" : ""

            const plural = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[k].amount != 0) ? "* " : ""
            const checkedClass = (this.props.extData.GetValgtPakkeIndex() == k) ? "extInfoRadioButton checked" : "extInfoRadioButton"

            if (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger.length > 1) {
                bufferEnh.push(
                    <div key={this.GetUnique()} onClick={e => this.OnClickEnh(k)} className={checkedClass}>
                        <h5 className="prefix">{titleStrB}</h5>
                        <div className="centerfix" style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", position: "relative", top: "3px", left: "8px" }}></div>
                        <h5 className="postfix">{plural + this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[k].pakningsEnhet.id + " (" + this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[k].pakningsEnhet.beskrivelse + ")"}</h5>
                    </div>)
            }
            else {
                bufferEnh.push(
                    <div key={this.GetUnique()} onClick={e => this.OnClickEnh(k)} style={{ height: "20px", display: "flex", flexDirection: "row", cursor: "pointer" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>{titleStrB}</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844", fontWeight: "normal" }}>{plural + this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[k].pakningsEnhet.id + " (" + this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[k].pakningsEnhet.beskrivelse + ")"}</h5>
                    </div>)
            }
        }

        // Adding info links after the units above, with a separation line, but if there are any such links registered, otherwise we're adding nothing at all
        if (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier != null) {
            if (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier.length > 0) {
                // Let's begin with the separation line...
                bufferEnh.push(<div key={this.GetUnique()} style={{ height: "8px", width: "100%", borderBottom: "1px solid #B9B9B9" }}> </div>)
    
                const leftMarginStr = "14px"

                // Then the title:
                bufferEnh.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "14px", fontWeight: "bold", width: "100%", textAlign: "left" }}>Informasjonslenker:</h5>
                    </div>)

                var linksCollection = new Array<JSX.Element>()

                // And finally the links are added, first into a collection (so that leaving their area with the mouse can be handled)
                for (var b = 0; b < this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier.length; b++) {
                    const index = b
                    const link = this.DescribeMediaType(this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier[b].url)

                    const hoverColor = (this.props.extData.GetHoveredMediaLink() == index) ? "#7777FF" : "#2255AA"
                    linksCollection.push(<a key={this.GetUnique()} href={this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier[b].url} target="_blank" style={{ height: "20px", width: "100%", fontVariant: "underlined" }}>
                        <div onMouseEnter={e => this.OnMouseEnterMediaLink(index)} style={{ height: "20px", width: "calc(100% -" + leftMarginStr + ")", marginLeft: leftMarginStr, color: hoverColor, cursor: "pointer", fontVariant: "underlined" }}>
                            {this.DescribeMediaType(this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].medier[b].mediaType) + this.GetNumericExtension(index)}
                        </div>
                    </a>)
                }

                bufferEnh.push(<div key={this.GetUnique()} onMouseLeave={e => this.OnMouseLeaveMedia()} style={{position: "relative", top:"4px"}}>
                        {linksCollection}
                    </div>
                )
            }
        }

        var mal = this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].pakningsMal
        
        // Preparing the radio options for dimensions (pakningsMal)
        if (mal != null) { // Checking first the dims arent null, to avoid crashes if it would be.
            const visibleCircleDim = (mal.length > 1) ? "visible" : "hidden"

            // Choise of option for the dimensions of the package
            if (mal.length > 0) {
                for (i = 0; i < mal.length; i++) {
                    const k = i
                    const offsetStr = "0px -" + (offset + (18 * ((this.props.extData.GetValgtDimIndex() == k) ? 1 : ((this.props.extData.GetHoveredDimIndex() == k) ? 2 : 0)))).toString() + "px"
                    const textColorStr = ((this.props.extData.GetValgtDimIndex() == k) ? "#000000" : ((this.props.extData.GetHoveredDimIndex() == k) ? "#000000" : "#333844"))
                    const fontWeightStr = ((this.props.extData.GetValgtDimIndex() == k) ? "bold" : ((this.props.extData.GetHoveredDimIndex() == k) ? "normal" : "normal"))
                    const titleStrC = (k == 0) ? "Pakningsmål:" : ""
                    
                    bufferDim.push(
                        <div key={this.GetUnique()} onClick={e => this.OnClickEnh(k)} style={{ height: "20px", display: "flex", flexDirection: "row", cursor: "pointer" }}>
                            <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>{titleStrC}</h5>
                            <div style={{ width: buttonWidthStr, height: buttonHeightStr, backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: offsetStr, position: "relative", left: "8px", top: "3px", visibility: visibleCircleDim }}></div>
                            <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: textColorStr, fontWeight: fontWeightStr, visibility: visibleCircleDim }}>{"Valg:" + k.toString()}</h5>
                        </div>
                    )
                }
            }

            // Bredde:
            if (mal[this.props.extData.GetValgtDimIndex()].bredde != null) {
                const breddeStr = mal[this.props.extData.GetValgtDimIndex()].bredde.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Bredde:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{breddeStr}</h5>
                    </div>)
            }

            // Hoyde:
            if (mal[this.props.extData.GetValgtDimIndex()].hoyde != null) {
                const hoydeStr = mal[this.props.extData.GetValgtDimIndex()].hoyde.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Høyde:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{hoydeStr}</h5>
                    </div>)
            }

            // Lengde:
            if (mal[this.props.extData.GetValgtDimIndex()].lengde != null) {
                const lengdeStr = mal[this.props.extData.GetValgtDimIndex()].lengde.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Lengde:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{lengdeStr}</h5>
                    </div>)
            }

            // Type:
            if (mal[this.props.extData.GetValgtDimIndex()].type != null) {
                const typeStr = mal[this.props.extData.GetValgtDimIndex()].type.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Type:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{typeStr}</h5>
                    </div>)
            }

            // Vekt:
            if (mal[this.props.extData.GetValgtDimIndex()].vekt != null) {
                const vektStr = mal[this.props.extData.GetValgtDimIndex()].vekt.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Vekt:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{vektStr}</h5>
                    </div>)
            }

            // Volum:
            if (mal[this.props.extData.GetValgtDimIndex()].volum != null) {
                const volumStr = mal[this.props.extData.GetValgtDimIndex()].volum.toString()
                bufferDim.push(
                    <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "normal", width: "80px", textAlign: "right", cursor: "pointer" }}>Volum:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, textAlign: "left", color: "#333844" }}>{volumStr}</h5>
                    </div>)
            }

            // Now, between the specifics above (or the indication of the lack of them) and the following two indicators (in store and orderable) there will be a separating line..
            bufferDim.push(<div key={this.GetUnique()} style={{ height: "8px", width: "100%", borderBottom: "1px solid #B9B9B9" }}>
            </div>)

            // In storage, available for ordering
            const inStorStr = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].lagerfort == true) ? "Ja" : "Nei"
            const inStorColor = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].lagerfort == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Lagerført:</h5>
                    <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, fontWeight:"bold", textAlign: "left", color: inStorColor }}>{inStorStr}</h5>
                </div>)

            const orderableStr = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].bestillbar == true) ? "Ja" : "Nei"
            const orderableColor = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].bestillbar == true) ? "#229922" : "#992222"
            bufferDim.push(
                <div key={this.GetUnique()} style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                    <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Bestillbar:</h5>
                    <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, fontWeight: "bold", textAlign: "left", color: orderableColor }}>{orderableStr}</h5>
                </div>) 
        }
        else {
            // Dimension data is missing, so only supplier and unit type will be displayed, while dimensions will be displayed as missing

            // In storage, available for ordering
            const inStorStr = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].lagerfort == true) ? "Ja" : "Nei"
            const inStorColor = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].lagerfort == true) ? "#229922" : "#992222"
            const orderableStr = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].bestillbar == true) ? "Ja" : "Nei"
            const orderableColor = (this.props.extData.GetLeverandorer()[this.props.extData.GetValgtLeverantorIndex()].pakninger[this.props.extData.GetValgtPakkeIndex()].bestillbar == true) ? "#229922" : "#992222"

            return <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "-3px" }}>
                <div style={{ height: heightStr, width: "34%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", borderRight: "1px solid #B9B9B9" }}>
                    {bufferLev}
                </div>
                <div style={{ height: heightStr, width: "34%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", borderRight: "1px solid #B9B9B9" }}>
                    {bufferEnh}
                </div>
                <div style={{ height: heightStr, width: "34%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9" }}> 
                    <div style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Lagerført:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, fontWeight: "bold", textAlign: "left", color: inStorColor }}>{inStorStr}</h5>
                    </div>
                    <div style={{ height: "20px", display: "flex", flexDirection: "row" }}>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", fontWeight: "bold", width: "80px", textAlign: "right", cursor: "pointer" }}>Bestillbar:</h5>
                        <h5 style={{ marginTop: "5px", marginLeft: "10px", width: widthRemainStr, fontWeight: "bold", textAlign: "left", color: orderableColor }}>{orderableStr}</h5>
                    </div>
                </div>
            </div>
        }

        // All 3 sections are ready for rendering, here a complete version is returned with dimension data included. 
        return <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "-3px" }}>
            <div style={{ height: heightStr, width: "100%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", borderRight: "1px solid #B9B9B9" }}>
                 {bufferLev}
            </div>
            <div style={{ height: heightStr, width: "100%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", borderRight: "1px solid #B9B9B9" }}>
                 {bufferEnh}
            </div>
            <div style={{ height: heightStr, width: "100%", display: "flex", flexDirection: "column", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9" }}>
                {bufferDim}
            </div>
        </div>
    }

    private m_index: number
    private m_clickedIndex: number // This number tells what radio button was clicked and will be used in onClick, which otherwise did not work using regular params in chrome
}


// WEBPACK FOOTER //
// ./client/view/ExtInfoRadioButton.tsx